<div *ngIf="!this.isLoading">
    <!-- <app-dashboard></app-dashboard> -->
    <router-outlet></router-outlet>
</div>
<div *ngIf="this.isLoading">
    <div class="d-flex justify-content-center align-items-center vh-100">
        <div class="p-5">
            <div class="d-flex">
                <div class="padding-summary">Loading..</div>
                <div><img src="./../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            </div>
        </div>
    </div>
</div>
